var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", [
      _c("div", { staticClass: "flex vertical-center input-container" }, [
        _c("div", { staticClass: "full-width" }, [
          _c("label", { attrs: { for: "email" } }, [
            _vm._v(_vm._s(_vm.step.label)),
          ]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.inputData,
                expression: "inputData",
              },
              { name: "focus", rawName: "v-focus" },
            ],
            staticClass: "input-styling",
            attrs: { type: "email", placeholder: _vm.step.placeholder },
            domProps: { value: _vm.inputData },
            on: {
              input: [
                function ($event) {
                  if ($event.target.composing) return
                  _vm.inputData = $event.target.value
                },
                _vm.updateParentValue,
              ],
            },
          }),
          _vm._v(" "),
          _vm.inputValid ? _c("div", { staticClass: "valid-check" }) : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "error-text-styling" }, [
        _vm.displayErrorMessage
          ? _c("div", [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.step.errorMessage) +
                  "\n            "
              ),
            ])
          : _vm._e(),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }